import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import VueFirestore from 'vue-firestore';
import axios from 'axios';
Vue.use(VueFirestore);
Vue.config.productionTip = false;

Vue.prototype.$http = axios;

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
}).$mount('#app');
